export const TRACEPARENT_HEADER = 'traceparent';
